import styled from '@emotion/styled';
import { colors, Stack, Typography } from '@ui-components/neo.tax';

import { KeywordSearch } from '../keyword-search';

export const EmptyStateOuter = styled(Stack)({
  flexGrow: 1,
});

export const EmptyStateInner = styled(Stack)({
  height: '66%',
});

export const ListFooterWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  flexGrow: 1,
  padding: '1rem',
});

export const MenuWrapper = styled(Stack)({
  height: '24rem',
  position: 'relative',
});

export const SearchWrapper = styled(Stack)({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 1,
  backgroundColor: colors.white,
});

export const StyledKeywordSearch = styled(KeywordSearch)({
  padding: '0.5rem',
});

export const ProjectList = styled(Stack)({
  display: 'block',
  overflowY: 'auto',
  flexGrow: 1,
  marginTop: 65,
});

export const TicketRowContainer = styled(Stack)({
  marginLeft: 16,
  maxHeight: 48,
});

export const TicketRowMainContent = styled(Stack)({
  flexGrow: 1,
});

export const TicketRowDetails = styled(Stack)({
  width: '0',
  flexGrow: 1,
});

export const TicketRowTitle = styled(Typography)({
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
});

export const TicketRowContributorName = styled(Typography)({
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  maxWidth: '200px',
  display: 'block',
});

export const ListFooterContainer = styled(Stack)({
  maxHeight: 28,
});

export const DisabledDot = styled('div')({
  width: '16px',
  height: '16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  '&::before': {
    content: '""',
    width: '4px',
    height: '4px',
    borderRadius: '50%',
    backgroundColor: colors.black,
  },
});

/** Every PR row renders at exactly this height, so an expanded list's height is known without measuring it. */
export const LINKED_PULL_REQUEST_ROW_HEIGHT = 44;
export const LINKED_PULL_REQUESTS_VERTICAL_PADDING = 8;

// Indented to the ticket title, past the row's left margin, padding, and checkbox.
export const LinkedPullRequestsContainer = styled(Stack)({
  marginLeft: 56,
  marginRight: 16,
  borderLeft: `2px solid ${colors.gray[200]}`,
  paddingLeft: 12,
  paddingTop: LINKED_PULL_REQUESTS_VERTICAL_PADDING,
  paddingBottom: LINKED_PULL_REQUESTS_VERTICAL_PADDING,
});

export const LinkedPullRequestRowContainer = styled(Stack)({
  height: LINKED_PULL_REQUEST_ROW_HEIGHT,
  minWidth: 0,
});

export const LinkedPullRequestIdentifier = styled(Typography)({
  flexShrink: 0,
  whiteSpace: 'nowrap',
});

export const LinkedPullRequestTitle = styled(Typography)({
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  minWidth: 0,
});

export const LinkedPullRequestMeta = styled(Typography)({
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  display: 'block',
});
